import request from '../utils/request'

// ========== 门户聚合 ==========
export const homeApi = () => request.get('/portal/home')
export const aboutApi = () => request.get('/portal/about')
export const companyApi = () => request.get('/portal/company')
export const legalPolicyApi = (code) => request.get('/portal/legal', { params: { code } })
export const categoriesApi = () => request.get('/portal/categories')
export const systemConfigApi = () => request.get('/portal/config')

// ========== 设备 ==========
export const equipmentListApi = (params) => request.get('/portal/equipment', { params })
export const equipmentDetailApi = (id) => request.get(`/portal/equipment/${id}`)

// ========== 服务 ==========
export const serviceListApi = (params) => request.get('/portal/service', { params })
export const serviceDetailApi = (id) => request.get(`/portal/service/${id}`)

// ========== 解决方案 ==========
export const solutionListApi = (params) => request.get('/portal/solution', { params })
export const solutionDetailApi = (id) => request.get(`/portal/solution/${id}`)

// ========== 新闻 ==========
export const newsPageApi = (params) => request.get('/portal/news', { params })
export const newsCarouselApi = (params) => request.get('/portal/news/carousel', { params })
export const newsDetailApi = (id) => request.get(`/portal/news/${id}`)

// ========== 客户咨询 ==========
export const submitInquiryApi = (data) => request.post('/portal/inquiry', data)
